export class SoggettoRuolo{
    id:number;
    ruolo:string;
}